import React from 'react';
import './Services.css';

const services = [
  {
    icon: '/images/mood-icon.png',
    title: 'Mood & Anxiety Disorders',
    desc: 'Depression, anxiety, bipolar disorder, OCD, and emotional disturbance — with evidence-based, compassionate care tailored to you.',
  },
  {
    icon: '/images/trauma-icon.png',
    title: 'Trauma & PTSD',
    desc: 'Specialized trauma-focused therapy using Brainspotting and EMDR to process and heal from difficult past experiences.',
  },
  {
    icon: '/images/grief-icon.png',
    title: 'Grief & Loss',
    desc: 'Support through grief, bereavement, divorce, and the profound emotional weight of significant life losses.',
  },
  {
    icon: '/images/transitions-icon.png',
    title: 'Life Transitions & Parenting',
    desc: 'Navigating career changes, relationship shifts, parenting challenges, school issues, and major life adjustments.',
  },
  {
    icon: '/images/career-icon.png',
    title: 'Career & Strengths',
    desc: 'Career counseling using MBTI and StrengthsFinder to clarify your path, build confidence, and align your work with your values.',
  },
  {
    icon: '/images/women-icon.png',
    title: "Women's Issues & Self-Esteem",
    desc: 'A culturally sensitive, empowering space addressing self-esteem, domestic issues, stress, and identity for women at any stage.',
  },
];

const Services = () => {
  return (
    <div className="services">
      <p className="services-label">What I Help With</p>
      <h2 className="services-heading">Areas of Expertise</h2>
      <hr className="services-rule" />

      <div className="services-grid">
        {services.map((s, i) => (
          <div key={s.title} className="service-card">
            <div className="service-card-icon">
              <img src={s.icon} alt="" />
            </div>
            <div className="service-card-body">
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          </div>

        ))}
      </div>
    </div>
  );
};

export default Services;